// extracted by mini-css-extract-plugin
export default {"info_box":"index_info_box_CkxdV clearfix","comment":"index_comment_MyYRx","pic":"index_pic_hV6-r","v_logo":"index_v_logo_cc-Ih","text":"index_text_8INOk","time":"index_time_Is3jq"};